import { createContext, useContext } from "react";
import { DynamicDataContext } from "../build/activeEntityType";

export type DynamicDataInfo = {
    dynamicDataScope: DynamicDataContext;
    dynamicDataObject?: any;
};

const DynamicDataTypeContext = createContext<DynamicDataInfo | undefined>(undefined);

export const DynamicDataSectionProvider = ({ children, value }: { children: React.ReactNode; value: DynamicDataInfo }) => {
    return <DynamicDataTypeContext.Provider value={value}>{children}</DynamicDataTypeContext.Provider>;
};

export const useDynamicDataSection = () => {
    const context = useContext(DynamicDataTypeContext);
    if (context === undefined) {
        throw new Error("useDynamicDataSection must be used within a DynamicDataSectionProvider");
    }
    return context;
};
